/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type ClaimStatusDTO = {
    previousStatus?: ClaimStatusDTO.previousStatus;
    status?: ClaimStatusDTO.status;
    note?: string;
    createdAt?: string;
};
export namespace ClaimStatusDTO {
    export enum previousStatus {
        NONE = 'NONE',
        RECEIVE = 'RECEIVE',
        ORDER_SPARE = 'ORDER_SPARE',
        RECEIVE_SPARE = 'RECEIVE_SPARE',
        REPAIRING = 'REPAIRING',
        TESTING = 'TESTING',
        REPAIR_SUCCESS = 'REPAIR_SUCCESS',
        REPAIR_FAIL = 'REPAIR_FAIL',
        CANCEL = 'CANCEL',
    }
    export enum status {
        NONE = 'NONE',
        RECEIVE = 'RECEIVE',
        ORDER_SPARE = 'ORDER_SPARE',
        RECEIVE_SPARE = 'RECEIVE_SPARE',
        REPAIRING = 'REPAIRING',
        TESTING = 'TESTING',
        REPAIR_SUCCESS = 'REPAIR_SUCCESS',
        REPAIR_FAIL = 'REPAIR_FAIL',
        CANCEL = 'CANCEL',
    }
}

